import { percentFormatter, currencyFormatter } from "./../../utils";

function Results({ results }) {
  const { interestRate, totalMonthlyPayments, totalInterest } = results;

  return (
    <div className="InterestRateAppResults">
      <div className="InterestRateAppResultsHeader">
        <strong>Results</strong>
      </div>
      <div className="InterestRateAppResultsSection">
        <span>Interest Rate</span>
        <span>{isNaN(interestRate) || interestRate < 0 ? '---' : percentFormatter(interestRate)}</span>
      </div>
      <div className="InterestRateAppResultsSection">
        <span>Total Monthly Payments</span>
        <span>{currencyFormatter(totalMonthlyPayments)}</span>
      </div>
      <div className="InterestRateAppResultsSection InterestRateAppResultsSectionDark">
        <span>Total Interest Paid</span>
        <span>{currencyFormatter(totalInterest)}</span>
      </div>
    </div>
  );
}

export default Results;
